<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        {{ modalTitle }}
      </p>
      <button @click="onClick('close')" type="button" class="close-icon">
        <i class="mdi mdi-close"></i>
      </button>
    </header>
    <section class="modal-card-body padding-bottom82">
      <p v-html="modalContent"></p>
    </section>
    <footer class="modal-card-foot">
      <button
        v-if="cancelButtonText"
        class="button is-primary bg-white color-black"
        @click="onClick('cancel')"
      >
        {{ cancelButtonText }}
      </button>

      <button class="button is-primary is-rounded" @click="onClick('confirm')">
        {{ confirmButtonText }}
      </button>
    </footer>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({ components: {} })
export default class InfoModal extends Vue {
  @Prop()
  public modalTitle!: string;
  @Prop()
  public modalContent!: string;
  @Prop()
  public confirmButtonText!: string;
  @Prop()
  public cancelButtonText!: string;

  public onClick(action: string) {
    this.$emit(action);
  }
}
</script>
<style module></style>
